import {
  DioboxEvent, EventEntryTarget, Form, FormStatus,
} from "sharedTypes"
import { formStatusAndColor } from "utilities/forms"

export const automaticTarget = (event: DioboxEvent): EventEntryTarget => (
  event.website?.published ? "site" : "portal"
)

export const chosenTarget = (event: DioboxEvent): EventEntryTarget => (
  event.rootTarget ?? automaticTarget(event)
)

const CLOSED_STATUSES = [FormStatus.Disabled, FormStatus.Ended, FormStatus.SoldOut]

export const webPageNote = (event: DioboxEvent) => (event.website?.published
  ? undefined
  : "The web page is not published, so the Event Link opens the Event Portal.")

export const formNote = (form: Form | undefined, event: DioboxEvent) => {
  if (!form) {
    return event.rootTarget === "form" && !event.rootFormId
      ? "The form was deleted, so the Event Link opens the Event Portal."
      : undefined
  }

  return CLOSED_STATUSES.includes(formStatusAndColor(form, event).status)
    ? "The form is closed, so the Event Link opens the Event Portal."
    : undefined
}
